<template>
  <v-container>
    <h1 class="title">Who will be the Registered Agent?</h1>
    <h3 class="subheading">
      By law, all incorporated businesses must have a Registered Agent on file with the state. A
      Registered Agent is someone that you designate to receive official documents for your business
      such as service of process, state correspondence, and other tax and legal documents.
    </h3>
    <h5 class="body-2">The many benefits of using our Registered Agent Service Include:</h5>
    <v-form ref="form">
      <v-radio-group v-model="agent">
        <v-radio :value="true" label="Legal House USA will be my agent" />
        <v-radio :value="false" label="My own agent" />
      </v-radio-group>
      <template v-if="!agent">
        <v-text-field v-model="name" :rules="[required]" label="Name of Agent" data-cy="name" />
        <v-text-field v-model="address" :rules="[required]" label="Address" data-cy="address" />
        <v-autocomplete
          v-model="state"
          :items="states"
          :rules="[required]"
          label="State"
          data-cy="state"
        />
        <v-text-field v-model="city" :rules="[required]" label="City" data-cy="city" />
        <v-text-field v-model="zip" :rules="[required]" label="Zip Code" data-cy="zip" />
      </template>
      <v-layout justify-space-around>
        <v-btn @click="$router.go(-1);">Back</v-btn>
        <v-btn color="info" @click="done">Continue</v-btn>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { omit } from 'lodash-es';
import firebase from 'firebase/app';
import 'firebase/database';
import { mapState } from 'vuex';
import { states } from '../util';

const db = firebase.database;

export default {
  data: () => ({
    address: '',
    agent: true,
    city: '',
    name: '',
    state: '',
    states,
    zip: '',
  }),
  computed: mapState(['token']),
  methods: {
    async done() {
      if (!this.agent && !this.$refs.form.validate()) return;
      await db()
        .ref(`info/${this.token}`)
        .update({
          agent: this.agent || omit(this.$data, ['agent', 'states']),
        });
      this.$router.push({ path: 'ein' });
    },
    required: field => !!field || 'This field is required',
  },
};
</script>
